import React from "react";

function UploadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      className="ml-2"
    >
      <path
        stroke="#B4B4B4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M7 11.083V2.917m0 0L2.917 7M7 2.917L11.083 7"
      ></path>
    </svg>
  );
  
}

export default UploadIcon;
